import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { NavLink, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";

const sectionIds = ["about", "skills", "projects", "contact"];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);

      if (!isHomePage) return;

      const scrollY = window.scrollY + 200;
      let current = "";

      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) {
          current = id;
        }
      }

      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  useEffect(() => {
    if (!isHomePage) setActiveSection("");
  }, [isHomePage]);

  const closeMenu = () => setMenuOpen(false);

  const getNavClass = (sectionId) => {
    if (!isHomePage) return "";
    return activeSection === sectionId ? "section-active" : "";
  };

  return (
    <div className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="logo">
        <div className="logo-dot" />
        <h2>Abhinav.dev</h2>
      </div>

      <div className="social-links">
        <ul className="unorder">
          <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
          <NavLink to="/about" onClick={closeMenu} className={getNavClass("about")}>About</NavLink>
          <NavLink to="/skill" onClick={closeMenu} className={getNavClass("skills")}>Skills</NavLink>
          <NavLink to="/project" onClick={closeMenu} className={getNavClass("projects")}>Projects</NavLink>
          <NavLink to="/contact" onClick={closeMenu} className={getNavClass("contact")}>Contact</NavLink>
        </ul>
      </div>

      <a
        href="mailto:abhinavpathak9984@gmail.com"
        className="navbar-hire-btn"
      >
        Hire Me
      </a>

      <div className="grid-button" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <HiX /> : <HiMenu />}
      </div>

      {menuOpen && (
        <ul className="mobile-list">
          <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
          <NavLink to="/about" onClick={closeMenu} className={getNavClass("about")}>About</NavLink>
          <NavLink to="/skill" onClick={closeMenu} className={getNavClass("skills")}>Skills</NavLink>
          <NavLink to="/project" onClick={closeMenu} className={getNavClass("projects")}>Projects</NavLink>
          <NavLink to="/contact" onClick={closeMenu} className={getNavClass("contact")}>Contact</NavLink>
          <a
            href="mailto:abhinavpathak9984@gmail.com"
            className="mobile-hire-btn"
            onClick={closeMenu}
          >
            Hire Me
          </a>
        </ul>
      )}
    </div>
  );
};

export default Navbar;
